import React, { JSX } from 'react';
import Style from './Title.module.scss';

type Props = {
  text: string;
  children?: React.ReactNode;
};

const Title: React.FC<Props> = ({ text, children }): JSX.Element => {
  return (
    <h2 className={Style.heading}>
      {text}
      {children}
    </h2>
  );
};

export default Title;
